export const toggleMobileSearch = value => ({
   type: 'TOGGLE_MOBILE_SEARCH',
   value,
});

export const updateWorkbench = html => ({
   type: 'UPDATE_WORKBENCH',
   html,
});

export const updateNotifications = notifications => ({
   type: 'UPDATE_NOTIFICATIONS',
   notifications,
});

export const updateMiniCart = miniCartInfo => ({
   type: 'UPDATE_MINI_CART',
   miniCartInfo,
});

export const toggleMobileMenu = () => ({
   type: 'TOGGLE_MOBILE_MENU',
});
